<template lang="html">
  <div id="builder-page" class="contained-height"  style="background-image: url(static/img/builder/team-bg.jpg)">
    <div class="container-fluid">
      <div class="row" v-for="(image, slideIndex) in slides" :key="slideIndex">
        <img
          class="builder-image"
          :src="assetsUrl + image.url"
          :class="{ active: slideIndex === index }"
          :key="image.id"
        >
        <!-- <div class="builder-block col-4" v-for="builder in builders"
        :class="{ active: builderReady }" :key="builder.name">
          <div class="builder-header px-5">
            <div class="builder-name mb-2 mt-3" v-html="builder.name">
            </div>
            <div class="builder-title mb-5" v-html="builder.title">
            </div>
          </div>
          <div class="builder-desc px-5" v-html="builder.desc">

          </div>
        </div> -->
      </div>
      <div class="neighbourhood-arrows position-absolute d-flex flex-row align-items-center justify-content-end">
        <div class="index pr-4">
          {{ index + 1 }} / {{ slides.length || 0}}
        </div>
        <div class="arrow-container d-flex flex-row align-items-center justify-content-end">
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="prevSlide()">
            <i class="fal fa-long-arrow-left"></i>
          </div>
          <div class="neighbourhood-arr d-flex flex-row align-items-center justify-content-center" @click="nextSlide()">
            <i class="fal fa-long-arrow-right"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data() {
    return {
      builders: [
        {
          name: 'Scott Armour McCrea',
          title: 'Chief Executive Officer, The Armour Group Limited',
          desc:
            'Builder, owner, and manager of Queen’s Marque, Scott leads all aspects of the design and development towards a singular vision. As Chief Executive of The Armour Group Limited, an investment and real estate practice located within Halifax, Scott continues a multi-generational philosophy of creating a “sense of place” – evident today in such landmarks as Historic Properties and Waterside Centre.  A graduate of the University of Western Ontario and Toronto in business and economics, his various awards include being selected as one of Canada’s top 40 under 40.<br /><br />A staunch supporter of opportunities within Atlantic Canada, Scott has set the principals of a district that can shape our imaginations of the future in context with our past.'
        },
        {
          name: 'Brian MacKay-Lyons',
          title:
            'Principal, FRAIC, MacKay-Lyons Sweetapple<br />Architects Limited',
          desc:
            'From this place, we can shape the world – clearly Brian MacKay-Lyons is a testament to this fact.  Born and raised in the village of Arcadia, Nova Scotia, Brian has developed a leading global practice from Nova Scotia that has been honored with over one hundred design awards including the Royal Institute of British Architects International Fellowship, the Royal Architectural Institute of Canada Gold Medal and two A.I.A. National Honor Awards. A current professor, and a graduate of Dalhousie University Architecture, along with a Masters from U.C.L.A, Brain was named an Honorary Fellow of the American Institute of Architects in 2001.<br/><br/>Brian is the lead design architect for Queen’s Marque where he melds the story, beauty, and the essence of being “born of this place” to the built form.  His expert take on regionalist architecture ensures our unique expression is evident within this district.'
        },
        {
          name: 'George Cotaras',
          title: 'President, FRAIC, Fowler Bauld & Mitchell<br />Architecture',
          desc:
            'If craft is the melding of science and art, then George Cotaras is a master craftsman of architecture.  The recipient of numerous awards within Canada and Japan, and the principal project architect behind Halifax’s beloved Central Library, George leads the Nova Scotia based Fowler Bauld & Mitchell in a diverse and deep practice within the region.  A graduate and past instructor of Dalhousie University Architecture, George is widely recognized as one of the region’s top practitioners and leader in sustainable built forms.<br /><br />George is the lead project architect for Queen’s Marque where he crafts the concepts and art of the form to a building that works – a design that will meet the test of time in this important location.'
        }
      ],
      builderReady: false,
      index: 0
    };
  },
  computed: {
    ...mapState({
      slides: state => state.builder.slides,
      assetsUrl: state => state.project.assetsUrl
    })
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
    prevSlide() {
      this.index -= 1;
      if (this.index < 0) {
        this.index = this.slides.length - 1;
      }
    },
    nextSlide() {
      this.index += 1;
      if (this.index === this.slides.length) {
        this.index = 0;
      }
    }
  },
  mounted() {
    // if (!window.modelReady) {
    // window.modelReady = this.modelLoaded.bind(this);
    // }
    // window.discoverLabelClicked = this.discoverLabelClicked.bind(this);
    // window.triggerResize = this.resizeToFixModel.bind(this);
    this.setPageReady(true);
    setTimeout(() => {
      this.builderReady = true;
    }, 250);
  },
  beforeDestroy() {
    this.setPageReady(false);
  },
  components: {}
};
</script>

<style lang="scss" scoped>
#builder-page {
  padding-top: 0;
  background-color: var(--background);
}

#builder-scale-model,
#scale-model {
  height: 100%;
  width: 100%;
}

.model-debug {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  color: black;
}

.interact-instructions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.interact-instructions-text {
  width: 130px;
  position: relative;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: hsla(0, 0, 0, 0.8);
  border-radius: 0.25rem;
}

#builder-lightbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#builder-slides {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--background);
  padding-bottom: 50px;
}

.btn-close {
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 999;
  color: var(--text);
  font-size: 0.8rem;

  &:hover {
    text-decoration: underline;
  }
}

.builder-block {
  height: 750px;
  margin-top: 150px;
  border-right: 1px solid #a7a8aa;
  text-align: left;

  opacity: 0;
  transform: translate3d(0, 30px, 0);
  transition: all 0.5s ease-out;

  &:nth-of-type(3) {
    border-right: 0px;
  }

  .builder-header {
    min-height: 100px;

    .builder-name {
      font-family: Didot-Regular;
      font-size: 33px;
      color: #496b80;
      letter-spacing: 0;
      line-height: 38px;
    }

    .builder-title {
      font-family: Scandia-Regular;
      font-size: 18px;
      color: #295673;
      letter-spacing: 0;
    }
  }

  .builder-desc {
    font-family: Scandia-Regular;
    font-size: 17px;
    color: #295673;
    letter-spacing: 0;
    line-height: 33px;
  }

  &.active {
    opacity: 1;
    transform: translate3d(0, 0px, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/BuilderPage/BuilderPage.vue